class AddMenuDTO{

    /**
     * 主键
     */
    id = "";

    /**
     * 菜单 / 权限名称
     */
    name = "";

    /**
     * 父菜单id
     */
    pid = "";

    /**
     * 菜单类型（C菜单 B按钮）
     */
    menuType = "";

    /**
     * 权限标识符
     */
    perms = "";

}
export default AddMenuDTO
